var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("router-view", {
        attrs: { "table-filters": _vm.tableFilters },
        on: {
          "update:tableFilters": function($event) {
            _vm.tableFilters = $event
          },
          "update:table-filters": function($event) {
            _vm.tableFilters = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }